import RecordItemView from '../../core/views/RecordItemView';
import template from './SelectionListItemView.hbs';
import './SelectionListItemView.css';

// eslint-disable-next-line max-len
const SelectionListItemView = RecordItemView.extend(/** @lends download/views/layers.SelectionListItemView */{
  template,
  className: 'selection-list-item record-item',
  events: Object.assign({}, RecordItemView.prototype.events, {
    'click .record-unselect': 'onRecordUnselectClicked',
  }),

  onRecordUnselectClicked() {
    this.model.selectForDownload(false, this.collection);
  },
});

export default SelectionListItemView;



// WEBPACK FOOTER //
// /~/eoxc/src/download/views/SelectionListItemView.js